import { useTheme } from 'styled-components';

import { useQuery } from '@tanstack/react-query';
import {
  drawerInviteAtom,
  infoSessionCancelledAtom,
} from 'atoms/inviteSession';
import { useSetAtom } from 'jotai';
import { FormattedMessage, useIntl } from 'react-intl';

import { useModals } from 'context';
import { EndUserState, getCareMatrixModuleUserData } from 'services/user';

import { Modal, Spinner } from 'components';
import { ConfirmComponentProps } from 'modals/Confirm';

import { CancelEventMobileProps } from './types';
// eslint-disable-next-line import/order
import { YogaTheme } from 'types/others';

import * as S from './styles';

const CancelEventMobile: React.FC<CancelEventMobileProps> = ({
  isOpen,
  modalKey,
  props,
  onClose,
}) => {
  const { openModal, closeModal } = useModals();
  const intl = useIntl();
  const theme: YogaTheme = useTheme();

  const setInfoSessionCancelled = useSetAtom(infoSessionCancelledAtom);
  const setDrawerInvite = useSetAtom(drawerInviteAtom);

  const {
    bookingID,
    onConfirmDelete,
    patientCognitoId,
    sessionStartAt,
    sessionID,
  } = props;

  const {
    isLoading,
    data: user,
    isError: isUserDataError,
  } = useQuery<EndUserState>({
    queryKey: ['getCareMatrixModuleUserData', patientCognitoId],
    queryFn: () => getCareMatrixModuleUserData(patientCognitoId),
  });

  function handleDeleteSession() {
    closeModal('cancelEventMobile');
    openModal<ConfirmComponentProps>('confirm', {
      props: {
        message: intl.formatMessage({
          id: 'CALENDAR_EVENT.DELETE_BOOKING_MODAL_TEXT',
        }),
        confirmLabel: intl.formatMessage({
          id: 'CALENDAR_EVENT.CANCEL_CONFIRM',
        }),
        onConfirm: () => {
          onConfirmDelete(bookingID);
        },
        hideIcon: false,
      },
    });
  }

  function handleRescheduleSession() {
    if (!user?.userID) return null;

    closeModal('cancelEventMobile');

    setInfoSessionCancelled({
      date: new Date(sessionStartAt),
      sessionID,
      enduserID: user.userID,
      fullName: user.fullName,
    });

    return setDrawerInvite('invite-schedule');
  }

  return (
    <Modal
      isOpen={isOpen}
      onAfterClose={() => {
        if (onClose) onClose();
      }}
      closeModal={() => closeModal(modalKey)}
      overlayStyle={{ alignContent: 'center' }}
      contentStyle={{
        maxHeight: `${theme.yoga.sizes.calendarEventContainerHeight}px`,
      }}
    >
      <S.Container>
        <S.Content>
          {!user || isUserDataError || isLoading ? (
            <Spinner customColor={theme.yoga.colors.primary} />
          ) : (
            <>
              <S.HeaderContainer>
                <S.Title>
                  <FormattedMessage id="CPPLATAFORM.CPTCCAREMATRIX.MODALTOCANCEL" />
                </S.Title>
              </S.HeaderContainer>
              <S.Footer>
                <S.StyledButton onClick={handleDeleteSession}>
                  <FormattedMessage id="CPPLATAFORM.CPTCCAREMATRIX.DROPDOWNMENUCANCEL" />
                </S.StyledButton>
                <S.StyledButtonOutline onClick={handleRescheduleSession}>
                  <FormattedMessage id="CPPLATAFORM.CPTCCAREMATRIX.DROPDOWNMENUCANCELANDCREATE" />
                </S.StyledButtonOutline>
              </S.Footer>
            </>
          )}
        </S.Content>
      </S.Container>
    </Modal>
  );
};
export default CancelEventMobile;
